import { FunctionComponent, useState } from 'react'
import styles from '../export.module.scss'
import { BrowserUpdated } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { Daycare } from '@/types/Daycare'
import ExportDialog from '../exportDialog.tsx'
import { ExportDataType } from '@/types/Export.ts'

interface ExportDaycaresProps {
    daycares: Daycare[]
}

const ExportDaycares: FunctionComponent<ExportDaycaresProps> = ({ daycares }: ExportDaycaresProps) => {
    const { t } = useTranslation()

    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)

    return (
        <>
            <a className={styles.Case} onClick={(): void => setIsDialogOpen(true)}>
                <p className={styles.CaseTitle}>{t('structureList')} </p>
                <BrowserUpdated className={styles.CaseIcon} />
            </a>
            {isDialogOpen && (
                <ExportDialog
                    type={ExportDataType.Daycares}
                    open={isDialogOpen}
                    handleClose={(): void => setIsDialogOpen(false)}
                    daycares={daycares}
                    minDate={''}
                />
            )}
        </>
    )
}

export default ExportDaycares
